<template>
  <div>
    <div class="sign-up-background">
      <card class="sign-up-cta-card text-center lg:mt-24">
        <h2 class="text-h2 mb-24">Sign up for Sittercity Premium</h2>
        <p class="text-body mb-24">
          Take advantage of your free Premium access to Sittercity and get the support your family needs
        </p>
        <Button variant="primary" size="medium" value="Get premium for free" @click="$emit('sign-up-click')" />
      </card>
      <img class="sc-logo" src="@/images/bh-benefits/sc-bh-logo.svg" alt="Sittercity logo" />
    </div>
  </div>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'SignUpSection',
  components: { Card, Button },
};
</script>
